export default "assets/example-2.eb2aaaa7bd6f3be4.png"